NtechApp.ChatForm = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._form = null;

    this._$searchInput = null;
    this._$searchSublabel = null;
    this._$searchHidden = null;

    // @todo -> Test for multiple autocomplete binds(On form reloads)
    this._searchAuto = null;
    this._submitLoader = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerShowNewMessageForm]", function(e) {
            me._loadChatForm();
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ChatForm.EVENT_NEW_CHAT_MESSAGE = "NtechApp.ChatForm.EventNewChatMessage";

NtechApp.proto(NtechApp.ChatForm, {
    _getLoadChatFormRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_load_chat_form';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_load_chat_form';
    },

    _getSaveChatFormRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_save_chat_form';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_save_chat_form';
    },

    _getSearchChatOpponentRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_chat_search_opponent';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_chat_search_opponent';
    },

    _loadChatForm: function() {
        var me = this;

        me._form = new NtechApp.ModalForm();
        me._form.load(me._getLoadChatFormRoute(), {}, function($form) {
            me._bindFormEvents.call(me, $form);
        });
    },

    _bindFormEvents: function($form) {
        var me = this;

        me._click.listen($form.find(".formHeader .close .button"), function(event) {
            me._unloadForm();
        });

        me._submitLoader = new NtechApp.Loader(18, 18, "absolute", $form.find("[data-formSubmit]"));
        me._submitLoader.getView().css({
            background: '#37bdb1',
            borderRadius: '9px'
        });

        me._$searchInput = $form.find("[data-autocompleteid='targetAccount']");
        me._$searchSublabel = $form.find("[data-autocompleteSublabelId='targetAccount']");
        me._$searchHidden = $form.find("[data-autocompleteHiddenId='targetAccount']");

        me._searchAuto = new NtechApp.Autocomplete(
            me._$searchInput,
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {
                    matchType: NtechApp.Autocomplete.MATCH_TYPES.FULL,
                    multiple: true,
                    getWidth: function ($input) { return $input.outerWidth() - 30; }
                }
            ),
            function() {
                var args = Array.prototype.slice.call(arguments);
                // Push page
                if(arguments.length == 3)
                    args.push(false);

                args.push($form);
                me._loadSearchOpponentResults.apply(me, args);
            }
        );
        me._searchAuto.setModalCss();
        me._bindSearchAutoEvents($form);

        me._click.listen($form, "[data-formSubmit]", function(e) {
            if($(e.target).closest(".formControl").find(".ntechapp-loader").hasClass("visible"))
                return;

            me._saveChatForm($form);
        });

        me._click.listen($form, ".formErrors", function() {
            $form.find(".formErrors").css("display", "none");
        });
    },

    _unloadForm: function() {
        var me = this;

        me._searchAuto.destroy();
        me._form.unload();
    },

    _enableLoader: function() {
        this._submitLoader.on().white();
    },

    _disableLoader: function() {
        this._submitLoader.off();
    },

    _bindSearchAutoEvents: function($form) {
        var me = this;

        $(me._searchAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, data) {
            me._insertSearchResults($form, data);
        });

        me._click.listen(me._searchAuto.getView(), "[data-loadNextSearchResults]", function(event) {
            if($(event.target).hasClass("lockLoadNextButton"))
                return;

            var $loadNext = $(event.target).addClass("selectedItem lockLoadNextButton");
            var page = $loadNext.attr("data-loadNextSearchResults");

            me._ajax.enableTextLoading($loadNext);
            me._loadSearchOpponentResults(
                me._searchAuto.getSearchVal(),
                NtechApp.bind("appendData", me._searchAuto),
                NtechApp.noop,
                page,
                $form
            );
        });

        me._click.listen($form, "[data-accountId]", function(e) {
            var $item = $(e.target).closest("[data-accountId]");
            $item.remove();
        });
    },

    _insertSearchResults: function($form, data) {
        var $results = $form.find(".targetAccountField .autoSelected");
        for(var i = 0; i < data.length; i++) {
            var $item = $("<div/>").addClass("multipleItem");
            var $rmIcon = $("<span/>").addClass("rmIcon");

            $item.attr("data-accountId", data[i].id);
            $item.append(data[i].text);
            $item.append($rmIcon);

            $results.append($item);
        }
    },

    _getAccountIds: function($form) {
        var ids = [];
        $.each($form.find("[data-accountId]"), function() {
            ids.push($(this).attr("data-accountId"));
        });

        return ids;
    },

    _loadSearchOpponentResults: function(searchVal, onFoundData, onNotFoundData, page, $form) {
        var me = this;
        var ids = this._getAccountIds($form);

        var params = {
            searchText: searchVal,
            searchPage: page || 0,
            addedIds: (ids.length == 0) ? "" : ids.join("|")
        };

        me._ajax.get({
            url: Routing.generate(me._getSearchChatOpponentRoute(), params),
            onSuccess: function(data) {
                if(data.hasResults)
                    onFoundData(data.html);
                else
                    onNotFoundData(data.html);
            }
        });
    },

    _showErrors: function($form, errors) {
        var me = this;
        var $errors = $form.find(".formErrors");

        $errors.css("display", "block");
        $errors.find(".errorBody > p").remove();

        for(var errorName in errors)
            $errors.find(".errorBody").append("<p>" + errors[errorName] + "</p>");
    },

    _saveChatForm: function($form) {
        var me = this;
        me._enableLoader();

        var ids = this._getAccountIds($form);

        var params = {
            accountIds: (ids.length == 0) ? "" : ids.join("|"),
            message: $form.find("#chat_messageText").val(),
            formData: {
                _token: $form.find("#chat__token").val()
            }
        };

        me._ajax.post({
            url: Routing.generate(me._getSaveChatFormRoute()),
            data: params,
            onSuccess: function(data) {
                NtechApp.ajaxPolling.forceNextPullRequest(function(pullData) {
                    $(me).trigger(NtechApp.ChatForm.EVENT_NEW_CHAT_MESSAGE, [data.chatId]);
                    me._unloadForm();
                });
            },
            onError: function(errors) {
                me._disableLoader();
                me._showErrors($form, errors);
            }
        });
    }
});